import HTTP from './axios';

const ConfigurationsService = {
  get: () => HTTP.get('/configurations').then((response) => response.data),
  update: (p) => HTTP.put('/configurations', p).then((response) => response.data),
};

export default ConfigurationsService;
